import { render, staticRenderFns } from "./ThankYouForSubscribingPage.vue?vue&type=template&id=12f0998a&scoped=true&"
import script from "./ThankYouForSubscribingPage.vue?vue&type=script&lang=js&"
export * from "./ThankYouForSubscribingPage.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouForSubscribingPage.vue?vue&type=style&index=0&id=12f0998a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f0998a",
  null
  
)

export default component.exports